/**
 * @generated SignedSource<<8d745e62493b06135196db2bf5e50f89>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LockReservationFlow = "GOODS_RECEPTION" | "SWAP" | "%future added value";
export type SpaceConfiguration = "BACE_CLATTERING_STANDARD" | "BACE_SATELLITE_LARGE_EXTENDED" | "BACE_SATELLITE_LARGE_STANDARD" | "BACE_SATELLITE_MEDIUM_EXTENDED" | "BACE_SATELLITE_MEDIUM_STANDARD" | "BACE_SATELLITE_SMALL_EXTENDED" | "BACE_SATELLITE_SMALL_SLIM" | "BACE_SATELLITE_SMALL_STANDARD" | "BACE_STOREFRONT_2XL" | "BACE_STOREFRONT_L" | "BACE_STOREFRONT_M" | "BACE_STOREFRONT_S" | "BACE_STOREFRONT_XL" | "BACE_TRUCK_HUB_STANDARD" | "THALIA_RENZ_STANDARD_M" | "THALIA_RENZ_STANDARD_S" | "THALIA_RENZ_STANDARD_XS" | "THALIA_RENZ_WIDE_M" | "THALIA_RENZ_WIDE_S" | "%future added value";
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type warenannahmeOverviewQuery$variables = {
  hubName: string;
  skipOwnedReservations: boolean;
};
export type warenannahmeOverviewQuery$data = {
  readonly deliveryRequests: {
    readonly nodes: ReadonlyArray<{
      readonly content: string;
      readonly createdAt: any;
      readonly hubId: string;
      readonly id: string;
      readonly preferredSize: string | null | undefined;
      readonly requesterOrganization: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
    };
    readonly id: string;
    readonly name: string;
    readonly organization: {
      readonly id: string;
    };
  };
  readonly lockReservations?: {
    readonly nodes: ReadonlyArray<{
      readonly contentNote: string | null | undefined;
      readonly deactivatedAt: any | null | undefined;
      readonly deliveredAt: any | null | undefined;
      readonly flow: LockReservationFlow;
      readonly id: string;
      readonly note: string | null | undefined;
      readonly space: {
        readonly configuration: SpaceConfiguration;
        readonly frame: string;
        readonly hub: {
          readonly id: string;
        };
        readonly position: number;
      };
      readonly startedAt: any;
      readonly subtype: {
        readonly __typename: "B2BlockReservationSubtype";
        readonly organization: {
          readonly id: string;
        };
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly unlockRequests: {
        readonly totalCount: number;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"WarenannahmeCardFragment">;
    }>;
  };
  readonly myUtilizationGrants: {
    readonly nodes: ReadonlyArray<{
      readonly deactivatedAt: any | null | undefined;
      readonly id: string;
      readonly permissions: ReadonlyArray<UtilizationGrantPermission>;
      readonly reservation: {
        readonly contentNote: string | null | undefined;
        readonly deactivatedAt: any | null | undefined;
        readonly deliveredAt: any | null | undefined;
        readonly flow: LockReservationFlow;
        readonly id: string;
        readonly note: string | null | undefined;
        readonly space: {
          readonly configuration: SpaceConfiguration;
          readonly frame: string;
          readonly hub: {
            readonly id: string;
          };
          readonly position: number;
        };
        readonly startedAt: any;
        readonly subtype: {
          readonly __typename: "B2BlockReservationSubtype";
          readonly organization: {
            readonly id: string;
          };
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
        readonly unlockRequests: {
          readonly totalCount: number;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"WarenannahmeCardFragment">;
      };
    }>;
  };
};
export type warenannahmeOverviewQuery = {
  response: warenannahmeOverviewQuery$data;
  variables: warenannahmeOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipOwnedReservations"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v2/*:: as any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": (v4/*:: as any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": (v4/*:: as any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = [
  (v2/*:: as any*/),
  (v3/*:: as any*/)
],
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "direction": "RECEIVED",
        "status": [
          "OPEN"
        ]
      }
    },
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 100
      }
    }
  ],
  "concreteType": "DeliveryRequestPage",
  "kind": "LinkedField",
  "name": "deliveryRequests",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DeliveryRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hubId",
          "storageKey": null
        },
        (v7/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "preferredSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "requesterOrganization",
          "plural": false,
          "selections": (v8/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "deliveryRequests(filter:{\"direction\":\"RECEIVED\",\"status\":[\"OPEN\"]},pagination:{\"page\":0,\"pageSize\":100})"
},
v10 = {
  "kind": "Literal",
  "name": "pagination",
  "value": {
    "page": 0,
    "pageSize": 1000
  }
},
v11 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  },
  (v10/*:: as any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deactivatedAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliveredAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentNote",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flow",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 1
      }
    }
  ],
  "concreteType": "UnlockRequestPage",
  "kind": "LinkedField",
  "name": "unlockRequests",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": "unlockRequests(pagination:{\"page\":0,\"pageSize\":1})"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frame",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": null
},
v24 = [
  (v2/*:: as any*/),
  (v14/*:: as any*/),
  (v15/*:: as any*/),
  (v12/*:: as any*/),
  (v16/*:: as any*/),
  (v17/*:: as any*/),
  (v18/*:: as any*/),
  {
    "kind": "CatchField",
    "field": (v19/*:: as any*/),
    "to": "NULL"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subtype",
    "plural": false,
    "selections": [
      (v20/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v5/*:: as any*/)
        ],
        "type": "B2BlockReservationSubtype",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v21/*:: as any*/),
      (v22/*:: as any*/),
      (v23/*:: as any*/),
      (v6/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "WarenannahmeCardFragment"
  }
],
v25 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "active": true,
      "flow": "GOODS_RECEPTION",
      "subtype": "B2B"
    }
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      {
        "field": "STARTED_AT",
        "ordering": "DESC"
      }
    ]
  },
  (v10/*:: as any*/)
],
v26 = [
  (v2/*:: as any*/),
  (v3/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  }
],
v27 = [
  (v2/*:: as any*/),
  (v14/*:: as any*/),
  (v15/*:: as any*/),
  (v12/*:: as any*/),
  (v16/*:: as any*/),
  (v17/*:: as any*/),
  (v18/*:: as any*/),
  (v19/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subtype",
    "plural": false,
    "selections": [
      (v20/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": (v8/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdByUserId",
            "plural": false,
            "selections": (v26/*:: as any*/),
            "storageKey": null
          }
        ],
        "type": "B2BlockReservationSubtype",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v21/*:: as any*/),
      (v22/*:: as any*/),
      (v23/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "hub",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HubMeta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*:: as any*/)
    ],
    "storageKey": null
  },
  (v7/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "deactivatedByUser",
    "plural": false,
    "selections": (v26/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UtilizationGrant",
    "kind": "LinkedField",
    "name": "deactivatedByGrant",
    "plural": false,
    "selections": [
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "toUser",
        "plural": false,
        "selections": (v26/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v28 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v29 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "DateTime"
},
v30 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v31 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
},
v32 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Organization"
},
v33 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "HubMeta"
},
v34 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "DateTime"
},
v35 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "UtilizationGrant"
},
v36 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "User"
},
v37 = {
  "enumValues": [
    "SWAP",
    "GOODS_RECEPTION"
  ],
  "nullable": false,
  "plural": false,
  "type": "LockReservationFlow"
},
v38 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Space"
},
v39 = {
  "enumValues": [
    "BACE_STOREFRONT_S",
    "BACE_STOREFRONT_M",
    "BACE_STOREFRONT_L",
    "BACE_STOREFRONT_XL",
    "BACE_STOREFRONT_2XL",
    "BACE_SATELLITE_SMALL_STANDARD",
    "BACE_SATELLITE_SMALL_SLIM",
    "BACE_SATELLITE_SMALL_EXTENDED",
    "BACE_SATELLITE_MEDIUM_STANDARD",
    "BACE_SATELLITE_MEDIUM_EXTENDED",
    "BACE_SATELLITE_LARGE_STANDARD",
    "BACE_SATELLITE_LARGE_EXTENDED",
    "BACE_CLATTERING_STANDARD",
    "BACE_TRUCK_HUB_STANDARD",
    "THALIA_RENZ_STANDARD_XS",
    "THALIA_RENZ_STANDARD_S",
    "THALIA_RENZ_STANDARD_M",
    "THALIA_RENZ_WIDE_S",
    "THALIA_RENZ_WIDE_M"
  ],
  "nullable": false,
  "plural": false,
  "type": "SpaceConfiguration"
},
v40 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Hub"
},
v41 = {
  "enumValues": [
    "ONLINE",
    "OFFLINE"
  ],
  "nullable": false,
  "plural": false,
  "type": "HubStatus"
},
v42 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v43 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "LockReservationSubtype"
},
v44 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UnlockRequestPage"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "warenannahmeOverviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v5/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v6/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      (v9/*:: as any*/),
      {
        "alias": null,
        "args": (v11/*:: as any*/),
        "concreteType": "UtilizationGrantPage",
        "kind": "LinkedField",
        "name": "myUtilizationGrants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UtilizationGrant",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "reservation",
                "plural": false,
                "selections": (v24/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
      },
      {
        "condition": "skipOwnedReservations",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v25/*:: as any*/),
            "concreteType": "LockReservationPage",
            "kind": "LinkedField",
            "name": "lockReservations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v24/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": "lockReservations(filter:{\"active\":true,\"flow\":\"GOODS_RECEPTION\",\"subtype\":\"B2B\"},orderBy:[{\"field\":\"STARTED_AT\",\"ordering\":\"DESC\"}],pagination:{\"page\":0,\"pageSize\":1000})"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "warenannahmeOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      (v9/*:: as any*/),
      {
        "alias": null,
        "args": (v11/*:: as any*/),
        "concreteType": "UtilizationGrantPage",
        "kind": "LinkedField",
        "name": "myUtilizationGrants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UtilizationGrant",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "reservation",
                "plural": false,
                "selections": (v27/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
      },
      {
        "condition": "skipOwnedReservations",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v25/*:: as any*/),
            "concreteType": "LockReservationPage",
            "kind": "LinkedField",
            "name": "lockReservations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v27/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": "lockReservations(filter:{\"active\":true,\"flow\":\"GOODS_RECEPTION\",\"subtype\":\"B2B\"},orderBy:[{\"field\":\"STARTED_AT\",\"ordering\":\"DESC\"}],pagination:{\"page\":0,\"pageSize\":1000})"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0f150cdd5f3d3b8daac81365c9084eb1",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "deliveryRequests": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "DeliveryRequestPage"
        },
        "deliveryRequests.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "DeliveryRequest"
        },
        "deliveryRequests.nodes.content": (v28/*:: as any*/),
        "deliveryRequests.nodes.createdAt": (v29/*:: as any*/),
        "deliveryRequests.nodes.hubId": (v30/*:: as any*/),
        "deliveryRequests.nodes.id": (v30/*:: as any*/),
        "deliveryRequests.nodes.preferredSize": (v31/*:: as any*/),
        "deliveryRequests.nodes.requesterOrganization": (v32/*:: as any*/),
        "deliveryRequests.nodes.requesterOrganization.id": (v30/*:: as any*/),
        "deliveryRequests.nodes.requesterOrganization.name": (v28/*:: as any*/),
        "hubMeta": (v33/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v30/*:: as any*/),
        "hubMeta.id": (v30/*:: as any*/),
        "hubMeta.name": (v28/*:: as any*/),
        "hubMeta.organization": (v32/*:: as any*/),
        "hubMeta.organization.id": (v30/*:: as any*/),
        "lockReservations": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservationPage"
        },
        "lockReservations.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "LockReservation"
        },
        "lockReservations.nodes.contentNote": (v31/*:: as any*/),
        "lockReservations.nodes.createdAt": (v29/*:: as any*/),
        "lockReservations.nodes.deactivatedAt": (v34/*:: as any*/),
        "lockReservations.nodes.deactivatedByGrant": (v35/*:: as any*/),
        "lockReservations.nodes.deactivatedByGrant.id": (v30/*:: as any*/),
        "lockReservations.nodes.deactivatedByGrant.toEmail": (v31/*:: as any*/),
        "lockReservations.nodes.deactivatedByGrant.toUser": (v36/*:: as any*/),
        "lockReservations.nodes.deactivatedByGrant.toUser.email": (v28/*:: as any*/),
        "lockReservations.nodes.deactivatedByGrant.toUser.id": (v30/*:: as any*/),
        "lockReservations.nodes.deactivatedByGrant.toUser.name": (v28/*:: as any*/),
        "lockReservations.nodes.deactivatedByUser": (v36/*:: as any*/),
        "lockReservations.nodes.deactivatedByUser.email": (v28/*:: as any*/),
        "lockReservations.nodes.deactivatedByUser.id": (v30/*:: as any*/),
        "lockReservations.nodes.deactivatedByUser.name": (v28/*:: as any*/),
        "lockReservations.nodes.deliveredAt": (v34/*:: as any*/),
        "lockReservations.nodes.flow": (v37/*:: as any*/),
        "lockReservations.nodes.id": (v30/*:: as any*/),
        "lockReservations.nodes.note": (v31/*:: as any*/),
        "lockReservations.nodes.space": (v38/*:: as any*/),
        "lockReservations.nodes.space.configuration": (v39/*:: as any*/),
        "lockReservations.nodes.space.frame": (v28/*:: as any*/),
        "lockReservations.nodes.space.hub": (v40/*:: as any*/),
        "lockReservations.nodes.space.hub.id": (v30/*:: as any*/),
        "lockReservations.nodes.space.hub.meta": (v33/*:: as any*/),
        "lockReservations.nodes.space.hub.meta.city": (v28/*:: as any*/),
        "lockReservations.nodes.space.hub.meta.id": (v30/*:: as any*/),
        "lockReservations.nodes.space.hub.meta.name": (v28/*:: as any*/),
        "lockReservations.nodes.space.hub.meta.postalCode": (v28/*:: as any*/),
        "lockReservations.nodes.space.hub.meta.street": (v28/*:: as any*/),
        "lockReservations.nodes.space.hub.status": (v41/*:: as any*/),
        "lockReservations.nodes.space.id": (v30/*:: as any*/),
        "lockReservations.nodes.space.position": (v42/*:: as any*/),
        "lockReservations.nodes.startedAt": (v29/*:: as any*/),
        "lockReservations.nodes.subtype": (v43/*:: as any*/),
        "lockReservations.nodes.subtype.__typename": (v28/*:: as any*/),
        "lockReservations.nodes.subtype.createdByUserId": (v36/*:: as any*/),
        "lockReservations.nodes.subtype.createdByUserId.email": (v28/*:: as any*/),
        "lockReservations.nodes.subtype.createdByUserId.id": (v30/*:: as any*/),
        "lockReservations.nodes.subtype.createdByUserId.name": (v28/*:: as any*/),
        "lockReservations.nodes.subtype.organization": (v32/*:: as any*/),
        "lockReservations.nodes.subtype.organization.id": (v30/*:: as any*/),
        "lockReservations.nodes.subtype.organization.name": (v28/*:: as any*/),
        "lockReservations.nodes.unlockRequests": (v44/*:: as any*/),
        "lockReservations.nodes.unlockRequests.totalCount": (v42/*:: as any*/),
        "myUtilizationGrants": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "UtilizationGrantPage"
        },
        "myUtilizationGrants.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrant"
        },
        "myUtilizationGrants.nodes.deactivatedAt": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.permissions": {
          "enumValues": [
            "END_RENTAL",
            "UNLOCK",
            "END_ON_OPEN"
          ],
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrantPermission"
        },
        "myUtilizationGrants.nodes.reservation": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservation"
        },
        "myUtilizationGrants.nodes.reservation.contentNote": (v31/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.createdAt": (v29/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedAt": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByGrant": (v35/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByGrant.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByGrant.toEmail": (v31/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByGrant.toUser": (v36/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByGrant.toUser.email": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByGrant.toUser.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByGrant.toUser.name": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByUser": (v36/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByUser.email": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByUser.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedByUser.name": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deliveredAt": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.flow": (v37/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.note": (v31/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space": (v38/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.configuration": (v39/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.frame": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub": (v40/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.city": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.name": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.postalCode": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.street": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.status": (v41/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.position": (v42/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.startedAt": (v29/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype": (v43/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.__typename": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId": (v36/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId.email": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId.name": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.organization": (v32/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.organization.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.organization.name": (v28/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.unlockRequests": (v44/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.unlockRequests.totalCount": (v42/*:: as any*/)
      }
    },
    "name": "warenannahmeOverviewQuery",
    "operationKind": "query",
    "text": "query warenannahmeOverviewQuery(\n  $hubName: String!\n  $skipOwnedReservations: Boolean!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    organization {\n      id\n    }\n    hub {\n      id\n    }\n  }\n  deliveryRequests(filter: {direction: RECEIVED, status: [OPEN]}, pagination: {page: 0, pageSize: 100}) {\n    nodes {\n      id\n      hubId\n      createdAt\n      content\n      preferredSize\n      requesterOrganization {\n        id\n        name\n      }\n    }\n  }\n  myUtilizationGrants(input: {}, pagination: {page: 0, pageSize: 1000}) {\n    nodes {\n      id\n      deactivatedAt\n      permissions\n      reservation {\n        id\n        startedAt\n        deliveredAt\n        deactivatedAt\n        contentNote\n        note\n        flow\n        unlockRequests(pagination: {page: 0, pageSize: 1}) {\n          totalCount\n        }\n        subtype {\n          __typename\n          ... on B2BlockReservationSubtype {\n            organization {\n              id\n            }\n          }\n        }\n        space {\n          frame\n          position\n          configuration\n          hub {\n            id\n          }\n        }\n        ...WarenannahmeCardFragment\n      }\n    }\n  }\n  lockReservations(filter: {subtype: B2B, flow: GOODS_RECEPTION, active: true}, orderBy: [{field: STARTED_AT, ordering: DESC}], pagination: {page: 0, pageSize: 1000}) @skip(if: $skipOwnedReservations) {\n    nodes {\n      id\n      startedAt\n      deliveredAt\n      deactivatedAt\n      contentNote\n      note\n      flow\n      unlockRequests(pagination: {page: 0, pageSize: 1}) {\n        totalCount\n      }\n      subtype {\n        __typename\n        ... on B2BlockReservationSubtype {\n          organization {\n            id\n          }\n        }\n      }\n      space {\n        frame\n        position\n        configuration\n        hub {\n          id\n        }\n      }\n      ...WarenannahmeCardFragment\n    }\n  }\n}\n\nfragment WarenannahmeCardFragment on LockReservation {\n  id\n  startedAt\n  createdAt\n  deactivatedAt\n  contentNote\n  note\n  deactivatedByUser {\n    id\n    name\n    email\n  }\n  deactivatedByGrant {\n    id\n    toEmail\n    toUser {\n      id\n      name\n      email\n    }\n  }\n  subtype {\n    __typename\n    ... on B2BlockReservationSubtype {\n      organization {\n        id\n        name\n      }\n      createdByUserId {\n        id\n        name\n        email\n      }\n    }\n  }\n  space {\n    id\n    frame\n    position\n    configuration\n    hub {\n      id\n      status\n      meta {\n        id\n        name\n        street\n        city\n        postalCode\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eec9b4f3e87b1425acead4aa20af29cc";

export default node;
